import { render, staticRenderFns } from "./templateAndForm.vue?vue&type=template&id=cc49d052&scoped=true"
import script from "./templateAndForm.vue?vue&type=script&lang=js"
export * from "./templateAndForm.vue?vue&type=script&lang=js"
import style0 from "./templateAndForm.vue?vue&type=style&index=0&id=cc49d052&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc49d052",
  null
  
)

export default component.exports